var _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgPlayVideo(_ref, svgRef) {
  let title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 15.011,
    height: 16.439,
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    "data-name": "Path 179"
  }, /*#__PURE__*/React.createElement("path", {
    "data-name": "Path 484",
    d: "M2.306 16.439a2.2 2.2 0 01-1.117-.292A2.637 2.637 0 010 13.757V2.683A2.421 2.421 0 013.855.45l9.679 5.555a2.4 2.4 0 010 4.434l-9.68 5.552a3.14 3.14 0 01-1.548.448zm0-14.44a.24.24 0 00-.117.024c-.093.054-.192.283-.192.66v11.074c0 .377.1.606.192.66s.343.025.669-.161l9.678-5.551c.346-.2.472-.4.472-.485s-.125-.283-.47-.48l-9.68-5.556a1.214 1.214 0 00-.549-.185z",
    fill: "#5200f1"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPlayVideo);
export default __webpack_public_path__ + "static/media/PlayVideo.9e5986899e75f9e45c4ece8bc4da0cb0.svg";
export { ForwardRef as ReactComponent };